<template>
    <div :class="classObj">
        <h1>{{title}}</h1>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 
                slot="header">
                You must have this information
            </h4>
            <span 
                slot="body">
                <p>When making a claim please ensure that you have the following information available to you as you will require it to complete the online claim form.</p>
                <ul>
                    <li>Your Policy Number</li>
                    <li>Full circumstances of your claim</li>
                    <li>Copies of the relevant documentation (see below)</li>
                </ul>
            </span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 
                slot="header">
                What documentation do I need to provide?
            </h4>
            <span slot="body">
                <p>We may ask you to provide one or more of the following to help us process your claim.</p>
                
                <h5>Proof of Purchase / Ownership</h5>
                <p>You must provide evidence to show that you own the gadget such as:
                    <ul>
                        <li>Original Purchase invoice</li>
                        <li>Contract Agreement from Network Provider (devices with SIM cards)</li>
                    </ul>
                </p>
                <p>The document must include the make, model and IMEI (in respect of mobile phones) or serial number together with the date of purchase of the device.  Please refer to the gadget criteria in the policy wording for further information.</p>
                
                <h5>Proof of Usage (mobile phones)</h5>
                <p>Proof of Usage from your Network provider which confirms the mobile phone has been in use since policy inception and up to the event giving rise to the claim. Proof of usage should include the device, make, model, IMEI number and the first and last date the device was used. This obtainable for all types of contract, including “pay as you go”.</p>

                <h5>Images of the Damage (Accidental Damage claims)</h5>
                <p>Please provide photographs of your gadget (front/back and each side).</p>

                <h5>Travel Documents</h5>
                <p>Booking invoice along with evidence of proof of travel such as boarding passes/used tickets.</p>

                <h5>Insurance Policy Schedule</h5>
                <p>The insurance document provided to you at time of taking out the policy. This is not the policy wording. It is the schedule showing your dates of travel, the insured persons and level of cover purchased.</p>

                <h5>Photographic ID</h5>
                <p>We will need a copy of your passport or UK driving licence (photographic version of the licence). We will need this for anyone claiming under the policy.</p>

                <h5>Proof of address</h5>
                <p>You will need to supply us with a utility bill (less than three months old) in your name at the address provided to us. This may be required for all persons claiming under the policy.</p>

                <h5>Theft &amp; Loss Claims</h5>
                <p><u>(Please also refer to the policy wording for full details of the claims procedure for all claims)</u></p>
                <p>If you gadget is lost or stolen, you must:</p>
                <ul>
                    <li>report the theft or loss of your gadget to your network provider within 24 hours of discovery so they can blacklist your handset/item (where this is applicable).</li>
                    <li>report the theft of your gadget to the Police within 24 hours of discovery and obtain a crime reference number and police report in support of a theft claim. Theft claims must be accompanied by a valid Police crime reference, loss property reports and numbers will not be accepted in support of a Theft claim.</li>
                    <li>report the loss of your gadget to the Police within 24 hours of discovery and obtain a loss number.</li>
                </ul>
                <p>The above points will need to be verified prior to any theft or loss claim being approved. If you have not carried out these requirements, then it is possible your claim may be delayed or even declined.</p>

                <h5>Proof of blacklisting</h5>
                <p>As stated in the process above, if you have a device that uses a sim card, you must have your device blacklisted if it has been lost or stolen. You must provide proof of this from your network provider. This will show when the device was blacklisted, the IMEI number, and is obtainable for all types of contract, including “pay as you go”.</p>


                <p>What is an IMEI number?
                    <ul>
                        <li>The IMEI number is unique to your handset and you can find this by typing *#06# in to your handsets key pad.</li>
                    </ul>

                </p>
            </span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">Do I need to pay an excess?</h4>
            <span slot="body"><p>An excess will apply to each person making a claim and to each incident and each section under the policy. Please refer to the Terms and Conditions of your Policy document to confirm which excess amount is applicable.</p></span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">How long will it take to receive a decision?</h4>
            <span slot="body"><p>We will assess your claim and aim to approve it within 48 working hours of receiving all requested documentation.</p></span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">How long will the repair take?</h4>
            <span slot="body"><p>Our repair centre will aim to repair your gadget within 72 working hours of receiving your device. Once your claim is approved, we will contact you to advise further on the repair process.</p></span>
        </collapsible-card>

        <collapsible-card class="mt-3" :is-tabbed="tabbed">
            <h4 slot="header">What if my gadget needs to be replaced?</h4>
            <span slot="body">
                <p>If your gadget is deemed beyond economical repair and will need to replaced, we will endeavour to replace it with an identical fully refurbished or new (where a refurbished item is not available) item. Should this not be possible we will replace it with a fully refurbished or new (where a refurbished item is not available) item of a comparable specification or the equivalent value.</p>
                <p><strong>Please note:</strong> it may not always be possible to replace your gadget with the same colour or finish, where this is not possible an alternative colour will be provided.</p>
            </span>
        </collapsible-card>
    </div>
</template>
<script>
import CollapsibleCard from '@/components/CollapsibleCard.vue'
export default {    
    components: {
        CollapsibleCard
    },
    props: {
        tabbed: {
            type: Boolean,
            default: false,
            notes: 'Used to pass prop to collapsible card component'
        },
        title: {
            type: String,
            default: 'Making a gadget claim...'
        }
    },
    computed: {
        classObj() {
            let klass = {};
            this.tabbed ? (klass["greyerbox"] = true) : (klass["greybox"] = true);

            return klass;
        }
    }
}
</script>

